import { useState, Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { Toaster } from 'sonner'
import { Sidebar } from './Sidebar'
import { TopBar } from './TopBar'
import { CommandPalette } from './CommandPalette'
import { AlertNotifier } from './AlertNotifier'
import { useThemeStore } from '@/stores/theme'

function ViewLoader() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
      <div style={{
        width: 24, height: 24, borderRadius: '50%',
        border: '2px solid var(--brand-blue)',
        borderTopColor: 'transparent',
        animation: 'spin 0.7s linear infinite',
      }} />
    </div>
  )
}

export function AppShell() {
  const [commandPaletteOpen, setCommandPaletteOpen] = useState(false)
  const { sidebarCollapsed } = useThemeStore()

  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: sidebarCollapsed ? '72px minmax(0, 1fr)' : '264px minmax(0, 1fr)',
      height: '100vh',
      transition: 'grid-template-columns .25s var(--ease-out)',
      background: 'var(--bg)',
    }}>
      <Sidebar />

      <main style={{ overflow: 'auto', background: 'var(--bg)', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
        <TopBar onOpenCommandPalette={() => setCommandPaletteOpen(true)} />

        <div style={{ flex: 1, overflow: 'auto' }}>
          <Suspense fallback={<ViewLoader />}>
            <Outlet />
          </Suspense>
        </div>
      </main>

      <CommandPalette
        open={commandPaletteOpen}
        onClose={() => setCommandPaletteOpen(false)}
      />

      <AlertNotifier />
      <Toaster position="top-right" richColors closeButton theme="light" />

      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>
    </div>
  )
}
